import { Dictionary, get } from "lodash";
import RestAPIClient from "services/RestAPIClient";
import { IAttribute } from "./typings";

class AttributeService extends RestAPIClient {
  constructor() {
    super("filters");
    this.caches = {};
  }

  private caches: Dictionary<IAttribute[]>;

  getAttributes = async ({
    kind,
  }: {
    kind:
      | "campaign-universal"
      | "campaign-partner"
      | "user"
      | "role"
      | "link-perf-partner"
      | "order-perf-partner"
      | "order-perf-universal"
      | "link-perf-universal"
      | "capacity"
      | "commission"
      | "program"
      | "program-manager"
      | "program-campaign-perf"
      | "invoice"
      | "coupon"
      | "invoice_campaign"
      | "invoice_order"
      | "payment"
      | "advertiser_invoice"
      | "advertiser_invoice_campaign"
      | "advertiser_invoice_order"
      | "advertiser_payment"
      | "program-order-perf"
      | "contract"
      | "audit-log"
      | "commission-history"
      | "dashboard-top-order"
      | "dashboard-top-sku"
      | "dashboard"
      | "report-campaign-perf"
      | "report-order-perf"
      | "pending_user"
      | "transaction"
      | "advertiser-contract"
      | "sub_user"
      | "share_access"
      | "share_access_admin"
      | "share_by_you"
      | "share_with_you"
      | "dashboard-top-order-affiliator"
      | "dashboard-top-sku-affiliator"
      | "group"
      | "website-configuration"
      | "ad-network-publishers"
      | "program-manager-seller"
      | "advertiser-report-campaign-perf"
      | "advertiser-report-order-perf"
      | "aff-topup"
      | "invoice_order_cpa"
      | "invoice_campaign_cpa"
      | "order-perf-universal-cpa"
      | "link-perf-universal-cpa"
      | "advertiser_invoice_campaign_cpa"
      | "advertiser_invoice_order_cpa"
      | "program-campaign-perf-cpa"
      | "program-order-perf-cpa";
  }): Promise<IAttribute[]> => {
    const cached = get(this.caches, kind);
    if (!!cached) return cached;
    const res = await this.get(`/${kind}`);
    this.caches[kind] = res.data;
    return res.data;
  };

  clearCache = () => {
    this.caches = {};
  };
}

export default new AttributeService();
